import React from 'react';
import { Home, Package, FileText, Users, Settings, List, PlusCircle, Upload, CreditCard, Truck, LayoutGrid, Factory, Warehouse } from 'lucide-react';

export const menuSections = [
  { name: 'Почетна', href: '/', icon: <Home size={18} /> },
  {
    name: 'Финансии',
    icon: <FileText size={18} />,
    prefix: ['/invoices', '/delivery-notes', '/payments'],
    children: [
      { name: 'Фактури', href: '/invoices/list', icon: <List size={16} />, description: 'Преглед на сите фактури.' },
      // headerTitle overrides what the app header shows for this screen — it
      // renders alone, with no section line above it. The sidebar entry keeps
      // its own longer `name`.
      { name: 'Нова фактура', href: '/invoices/create', icon: <PlusCircle size={16} />, description: 'Креирај нова фактура.', headerTitle: 'Нова' },
      { name: 'Испратници', href: '/delivery-notes/list', icon: <Truck size={16} />, description: 'Преглед на испратници.' },
      { name: 'Плаќања', href: '/payments/list', icon: <CreditCard size={16} />, description: 'Преглед на примени плаќања.' },
    ],
  },
  {
    name: 'Продукти',
    icon: <Package size={18} />,
    prefix: ['/products', '/categories', '/manufacturer', '/warehouse'],
    children: [
      { name: 'Сите продукти', href: '/products/list', icon: <List size={16} />, description: 'Преглед на сите производи.' },
      { name: 'Импорт', href: '/products/import', icon: <Upload size={16} />, description: 'Увези производи од датотека.' },
      { name: 'Категории', href: '/categories/list', icon: <LayoutGrid size={16} />, description: 'Преглед и уредување на категории.' },
      { name: 'Производители', href: '/manufacturer/list', icon: <Factory size={16} />, description: 'Преглед на производители.' },
      { name: 'Магацин', href: '/warehouse/list', icon: <Warehouse size={16} />, description: 'Состојба и залихи во магацинот.' },
    ],
  },
  {
    name: 'Партнери',
    icon: <Users size={18} />,
    href: '/partners/list',
    prefix: '/partners',
  },
  {
    name: 'Подесувања',
    icon: <Settings size={18} />,
    href: '/settings/mybussiness',
    prefix: '/settings',
    bottom: true,
  },
];

// `prefix` may be a single string or an array of them. Anything comparing a
// pathname against it MUST go through here: `pathname.startsWith(someArray)`
// silently coerces the array to "/a,/b,/c" and always returns false.
export function matchesPrefix(pathname, prefix) {
  return [].concat(prefix || []).some((p) => pathname.startsWith(p));
}

// First prefix is the section's root — the destination when its collapsed icon
// is clicked. Returns undefined for sections without a prefix.
export function sectionRoot(section) {
  return [].concat(section.prefix || [])[0];
}

export function getPageTitle(pathname) {
  for (const section of menuSections) {
    if (section.href === pathname) return { section: section.name, page: null };
    if (section.children) {
      // Checked before the exact match, and by prefix, so sub-routes such as
      // /invoices/create/:id behave the same. The section line stays; only the
      // page's own title is replaced by the shorter override.
      const overridden = section.children.find(
        (c) => c.headerTitle && pathname.startsWith(c.href)
      );
      if (overridden) return { section: section.name, page: overridden.headerTitle };

      const child = section.children.find((c) => c.href === pathname);
      if (child) return { section: section.name, page: child.name };
    }
    if (matchesPrefix(pathname, section.prefix)) {
      return { section: section.name, page: null };
    }
  }
  return { section: null, page: null };
}
